import { useEffect, useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { NAV_LINKS, BRAND } from "../lib/data";
import logo from "../assets/logo.png";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
  };

  useEffect(() => {
    if (!open) return;
    const close = (event) => { if (event.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [open]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled || open ? "bg-brand-surface/95 backdrop-blur-xl border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
           className="flex items-center">
          <img src={logo} alt="ECU SOLUTIONS Lorenzen" className="h-12 sm:h-14 w-auto" />
        </a>

        <nav aria-label="Hauptnavigation" className="hidden lg:flex items-center gap-5 xl:gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              href={l.href}
              onClick={(event) => { event.preventDefault(); go(l.href); }}
              className="font-mono text-xs uppercase tracking-[0.15em] text-brand-light/0 text-white/70 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            data-testid="header-whatsapp-btn"
            aria-label="ECU SOLUTIONS per WhatsApp kontaktieren"
            href={`https://wa.me/${BRAND.whatsapp}`}
            target="_blank" rel="noreferrer"
            className="w-11 h-11 flex items-center justify-center border border-slate-700 text-white hover:border-[#25D366] hover:text-[#25D366] transition-colors"
          >
            <MessageCircle size={18} />
          </a>
          <button
            data-testid="header-contact-cta"
            onClick={() => go("#kontakt")}
            className="bg-brand hover:bg-brand-light text-white font-semibold py-3 px-6 border border-brand-light/40 transition-colors hover:shadow-[0_0_24px_rgba(0,85,255,0.45)] uppercase tracking-wider text-xs"
          >
            Kontakt
          </button>
        </div>

        <button data-testid="mobile-menu-toggle" aria-label={open ? "Menü schließen" : "Menü öffnen"}
          aria-expanded={open} aria-controls="mobile-navigation" className="lg:hidden text-white w-11 h-11 flex items-center justify-center" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <nav id="mobile-navigation" aria-label="Mobile Navigation" data-testid="mobile-menu" className="lg:hidden bg-brand-surface border-t border-white/5 px-6 py-6 flex flex-col gap-2 max-h-[calc(100svh-80px)] overflow-y-auto" data-lenis-prevent>
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={(event) => { event.preventDefault(); go(l.href); }}
              className="font-mono text-sm uppercase tracking-wider text-white/80 text-left py-3">
              {l.label}
            </a>
          ))}
          <button onClick={() => go("#kontakt")}
            className="bg-brand text-white font-semibold py-3 px-6 uppercase tracking-wider text-xs mt-2">
            Kontakt
          </button>
        </nav>
      )}
    </header>
  );
};
